import { RouteView } from '@/layouts';

const brandRouter = {
  path: '/brand',
  name: 'Brand',
  redirect: '/brand/list',
  component: RouteView,
  meta: {
    title: '品牌管理',
    icon: 'iconbrand',
    roles: ['admin'],
  },
  hideChildrenInMenu: true,
  children: [
    {
      path: 'list',
      name: 'BrandList',
      component: () => import('@/views/brand/List'),
      meta: {
        title: '品牌列表',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'add',
      name: 'BrandAdd',
      component: () => import('@/views/brand/Add'),
      meta: {
        title: '品牌添加',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'editor',
      name: 'BrandEditor',
      component: () => import('@/views/brand/Editor'),
      meta: {
        title: '品牌编辑',
        roles: ['admin'],
        hidden: true,
      },
    },
  ],
};

export default brandRouter;
